export default {"src":"/_next/static/media/checkBoxSmallGreen_24.77300004.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};